import { render, staticRenderFns } from "./draftModal.vue?vue&type=template&id=46916d84&scoped=true&"
import script from "./draftModal.vue?vue&type=script&lang=js&"
export * from "./draftModal.vue?vue&type=script&lang=js&"
import style0 from "./draftModal.vue?vue&type=style&index=0&id=46916d84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46916d84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tsunagaru-v3-app-mintenant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46916d84')) {
      api.createRecord('46916d84', component.options)
    } else {
      api.reload('46916d84', component.options)
    }
    module.hot.accept("./draftModal.vue?vue&type=template&id=46916d84&scoped=true&", function () {
      api.rerender('46916d84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/shared/components/modal/draftModal.vue"
export default component.exports